import { render, staticRenderFns } from "./onboardingComplete.vue?vue&type=template&id=ed83acd8&scoped=true"
import script from "./onboardingComplete.vue?vue&type=script&lang=js"
export * from "./onboardingComplete.vue?vue&type=script&lang=js"
import style0 from "./onboardingComplete.vue?vue&type=style&index=0&id=ed83acd8&prod&lang=scss"
import style1 from "./onboardingComplete.vue?vue&type=style&index=1&id=ed83acd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed83acd8",
  null
  
)

export default component.exports